<template>
    <out-of-stock :custom-message="message" />
</template>

<script>
    import OutOfStock from '../../../../library/OutOfStock';
    import {getCustomizableText} from '../../../../../helpers/activations/default-texts';

    export default {
        name:       'OutOfStockBrief',
        components: {
            OutOfStock,
        },
        props: {
            brief: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            message() {
                return getCustomizableText(this.brief, 'products_out_of_stock');
            },
        },
    };
</script>
